var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.predicate)?_c('div',{staticClass:"text-center pt-4 pb-4"},[_c('b-spinner',{staticClass:"align-middle",staticStyle:{"width":"3rem","height":"3rem"}})],1):_c('div',{},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }